<template>
  <div class="c-idea-table" ref="ideaTable">
    <!-- <Spin size="large" fix v-if="value"></Spin> -->
    <el-table
      ref="table"
      :height="height"
      row-key="creativeId"
      class="summary-el-table-styles common-el-table-styles"
      v-loading="value"
      :data="data"
      show-summary
      stripe
      border
      @cell-mouse-enter="rowEnter"
      @cell-mouse-leave="rowLeave"
      @selection-change="select"
      @sort-change="sortChange"
      @header-dragend="headerDragend"
      :summary-method="getSummaries"
    >
      <el-table-column type="selection" width="39"> </el-table-column>
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :min-width="col.width"
        :sortable="col.sortable"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :formatter="col.format"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'switch'">
            <i-Switch v-model="scope.row.optStatus" @on-change="changeActive(scope.row)" size="small" />
            <Button v-if="scope.row.origin" type="primary" size="small" shape="circle">内</Button>
          </div>
          <div v-else-if="col.key === 'creativeId'">
            <span class="m-inblock">{{ scope.row['creativeName'] }}</span>
            <span class="m-inblock">{{ scope.row[col.key] }}</span>
          </div>
          <div v-else-if="col.key === 'creative'">
            <span>{{ scope.row.title }}</span>
            <div v-if="scope.row.imageMode" :class="{ 'c-wapper': scope.row.videoImageUrl || scope.row.imageList }">
              <div v-if="scope.row.videoImageUrl" :class="imageModeClasses(scope.row.imageMode)">
                <img :src="scope.row.videoImageUrl" alt="" />
              </div>
              <div v-if="scope.row.imageList" :class="imageModeClasses(scope.row.imageMode)">
                <img v-for="(img, idx) in scope.row.imageList" :key="idx" :src="img" alt="" />
              </div>
              <div
                v-if="scope.row.imageMode.includes('VIDEO') && scope.row.videoUrl"
                class="c-icon-play"
                @click="showVideo(scope.row.videoUrl)"
              >
                <Icon type="md-arrow-dropright-circle" size="68" color="#FFFFFF" />
              </div>
            </div>
          </div>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="editClick(scope.row)" class="m-control-btn" :disabled="[45].includes(media)"
              >修改</el-button
            >
          </div>
          <a v-else-if="col.key === 'adName'" @click.prevent="clickPlan(scope.row)">{{ scope.row[col.key] }}</a>
          <a v-else-if="col.key === 'adGroupName'" @click.prevent="clickGroup(scope.row)">{{ scope.row[col.key] }}</a>
          <span v-else-if="col.key === 'paperAmount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'amount'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'pv'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'clickNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'clickRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'perClickPrice'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'thousandsOfDisplayCosts'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'activeRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'convertNum'">{{ scope.row[col.key] | toThousands }}</span>
          <span v-else-if="col.key === 'convertRate'">{{ scope.row[col.key] | toPercentFixed }}</span>
          <span v-else-if="col.key === 'status' && scope.row.status !== 4">{{ scope.row.status | adStatus }}</span>
          <el-popover v-else-if="col.key === 'status' && scope.row.status === 4" trigger="hover" placement="top" :width="320">
            <h3 class="m-status-title">审核拒绝理由</h3>
            <p class="m-status-reason">{{ scope.row.auditRejectReason }}</p>
            <span slot="reference" class="m-status-rejust">{{ scope.row.status | adStatus }}</span>
          </el-popover>
          <a :href="scope.row.pageUrl" target="_blank" v-else-if="col.key === 'pageUrl'">{{ scope.row.pageUrl }}</a>
          <span v-else-if="col.key === 'createTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else-if="col.key === 'synTime'">{{ scope.row[col.key] | datetimeToMin }}</span>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>

    <betch-error v-model="betchShow" :data="betchErr" :columns="betchColumns"></betch-error>
  </div>
</template>
<script>
import mixin from './mixin'
import { setLocalInfo } from '@/common/js/utils'
import { toThousands } from '@/common/js/filters'
import { editGroupName, batchOperatorIdea } from '@/api/convert.model'
import BetchError from '@/components/converter/betch-error.vue'
export default {
  name: 'ideaTable',
  mixins: [mixin],
  components: {
    BetchError
  },
  props: {
    value: {
      type: Boolean
    },
    data: {
      type: Array
    },
    columns: {
      type: Array
    },
    media: {
      type: Number
    },
    height: {
      type: Number
    }
  },
  computed: {
    mediaHtml() {
      let name = ''
      if (this.media === 10) name = 'create/toutiao'
      else if (this.media === 6) name = 'create/uc'
      else if (this.media === 16) name = 'create/tencent'
      else if (this.media === 45) name = 'create/baidu'
      else if (this.media === 32) name = 'create/kuaishou'
      return name
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    // 合计自定义
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      let totalAmount = 0 // 总实际消耗
      let totalRegister = 0 // 总注册数
      let totalPaperAmount = 0 // 总账面消耗
      let totalConverterNum = 0 // 总转化数
      let convertCostIndex // 转化成本索引
      let registerCostIndex // 注册成本索引
      columns.forEach((column, index) => {
        const prop = column.property
        if (index === 1) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[prop]))
        if (
          [
            'paperAmount',
            'amount',
            'pv',
            'click',
            'activeNum',
            'convertNum',
            'convertCost',
            'register',
            'registerCost',
            'payCount',
            'payAmount',
            'appCheckoutCount'
          ].includes(prop) &&
          !values.every((value) => isNaN(value))
        ) {
          const sum = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          // 用于求平均注册、转化成本
          if (column.property === 'amount') totalAmount = sum
          if (column.property === 'register') totalRegister = sum
          if (column.property === 'paperAmount') totalPaperAmount = sum
          if (column.property === 'convertNum') totalConverterNum = sum
          if (prop === 'convertCost') convertCostIndex = index
          if (prop === 'registerCost') registerCostIndex = index
          sums[index] = sum.toString().includes('.') ? toThousands(parseFloat(sum.toFixed(2))) : toThousands(sum)
        } else {
          sums[index] = ''
        }
      })
      sums[convertCostIndex] = totalConverterNum ? parseFloat(totalPaperAmount / totalConverterNum).toFixed(2) : totalPaperAmount.toFixed(2)
      sums[registerCostIndex] = totalRegister ? parseFloat(totalAmount / totalRegister).toFixed(2) : totalRegister
      return sums
    },
    // 修改跳转
    editClick(row) {
      setLocalInfo(row.adAccountId, row.adAccountName, this.$store.state.Convert.media)
      if (this.media === 6) window.open(`/${this.mediaHtml}/idea/${row.adGroupId}/${row.adId}?id=${row.creativeId}&t=edit`, '_blank')
      else window.open(`/${this.mediaHtml}/idea/${row.adGroupId}/${row.adId}?plan=${row.planId}&t=edit`, '_blank')
    },
    // 鼠标经过显示修改笔
    rowEnter(row) {
      this.$set(row, 'editState', true)
    },
    rowLeave(row) {
      this.$set(row, 'editState', false)
    },
    // 改变编辑状态
    changEdit(row) {
      this.$set(row, 'edit', true)
    },
    cancelEdit(row) {
      this.saving = false
      this.$set(row, 'edit', false)
    },
    // 修改广告组名称
    edit(row) {
      this.saving = true
      editGroupName({
        adAccountId: row.adAccountId,
        adGroupId: row.adGroupId,
        newAdGroupName: row.adGroupName
      }).then((data) => {
        this.saving = false
        if (data) {
          // 修改成功后更新
          this.$set(row, 'edit', false)
          this.$emit('on-refresh')
        }
      })
    },
    // 开关
    changeActive(row) {
      let { optStatus } = row
      optStatus = optStatus ? 1 : 0
      if ([1, 0].includes(optStatus)) {
        this.betch(optStatus, [row])
      }
    },
    select(val) {
      this.selectList = val
    },
    // 批量操作
    changeBetch(type) {
      const len = this.selectList.length
      if (!len) {
        this.$Message.warning({
          duration: 5,
          content: '当前未选中任何创意，请在列表中选择一个或多个创意再进行此操作。'
        })
        return
      }

      // 删除二次验证
      if (type < 0) {
        this.$Modal.confirm({
          title: '提示',
          content: `<p>当前选中${len}条创意，确定删除吗？</p>`,
          onOk: () => {
            this.betch(type, this.selectList)
          }
        })
      } else {
        this.betch(type, this.selectList)
      }
    },
    betch(type, row) {
      type = type === 2 ? 0 : type
      batchOperatorIdea({
        type,
        creativeIds: row
      }).then((data) => {
        if (data) {
          const { failNum, rows } = data
          if (failNum && row.length > 1) {
            // 显示错误列表
            this.betchErr = rows
            this.betchShow = true
            return
          } else if (failNum && row.length === 1) {
            this.$Message.error({
              duration: 5,
              content: rows[0].error
            })
            this.$set(row, 'optStatus', type === 0)
          } else {
            this.$Message.success({
              duration: 5,
              content: '操作成功'
            })
          }
          this.$emit('on-refresh')
        }
      })
    },
    imageModeClasses(mode) {
      let className
      if (mode && mode.includes('VERTICAL')) {
        className = 'vertical-img'
      } else if (mode && mode.includes('GROUP')) {
        className = 'group-img'
      } else {
        className = 'image-img'
      }
      return className
    },
    showVideo(url) {
      window.open(url, '_blank')
    },
    clickGroup(row) {
      const { adGroupId, adGroupName } = row
      this.$store.commit('setIndexRoute', 'group')
      this.$router.push({
        name: 'advert',
        query: {
          media: this.media,
          id: adGroupId,
          name: encodeURI(adGroupName)
        }
      })
    },
    clickPlan(row) {
      const { adGroupId, adGroupName, adId, adName, adAccountId } = row
      if (this.media === 6) {
        this.$router.push({
          name: 'idea',
          query: {
            id: adGroupId,
            adAccountId: adAccountId,
            adId
          }
        })
      } else {
        this.$store.commit('setIndexRoute', 'plan')
        this.$router.push({
          name: 'creative',
          query: {
            media: this.media,
            id: adGroupId,
            name: encodeURI(adGroupName),
            adId,
            adName: encodeURI(adName)
          }
        })
      }
    },
    headerDragend(n, o, column) {
      this.$emit('header-dragend', { n, o, column })
    },
    doLayout() {
      this.$refs.table.doLayout()
    }
  },
  data() {
    return {
      saving: null, // 修改请求状态
      selectList: [], // 选中
      betchErr: [], // 批量错误
      betchShow: false, // 批量错误弹窗
      betchColumns: [
        {
          key: 'mediaName',
          title: '媒体名称'
        },
        {
          key: 'creativeId',
          title: '创意ID'
        },
        {
          key: 'error',
          title: '结果'
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.c-idea-table {
  position: relative;
  background-color: #fff;

  .el-table {
    .m-control-btn {
      margin: 0;
      padding: 0 3px;
    }
  }

  .c-wapper {
    width: 214px;
    height: 120px;
    position: relative;

    .c-icon-play {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    img {
      width: 100%;
      height: 100%;
    }

    .vertical-img {
      width: 120px;
      height: 120px;
      margin: 0 auto;
    }

    .group-img {
      width: 214px;
      height: 110px;

      img {
        width: 71.333px;
      }
    }

    .image-img {
      width: 100%;
      height: 100%;
    }
  }

  .m-inblock {
    display: block;
    line-height: 18px;
  }

  .m-status-rejust {
    color: #ff6600;
  }
}

.m-status-title {
  font-size: 14px;
  text-align: center;
  color: #333;
  margin-bottom: 8px;
}

.m-status-reason {
  line-height: 22px;
  font-size: 12px;
  color: #666;
}
</style>
